import Cmi5 from "@rusticisoftware/cmi5";

let cmi5;

export const getCmi5 = function() {

    if( !cmi5 ) {
        console.log("Initialize cmi5 lib...");
        cmi5 = new Cmi5( document.location.href );
    }

    return cmi5;
};
